import { render } from "./ClusterLink.vue?vue&type=template&id=5a5fa6c7&scoped=true"
import script from "./ClusterLink.vue?vue&type=script&lang=js"
export * from "./ClusterLink.vue?vue&type=script&lang=js"

import "./ClusterLink.vue?vue&type=style&index=0&id=5a5fa6c7&lang=scss&scoped=true"

import exportComponent from "../../../../dashboard-mellow-embed-clipboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a5fa6c7"]])

export default __exports__